(function () {
  const ACCESS_TOKEN = '1b1ac2a197d2c8';
  const STORAGE_KEY = "holster_eu_popup_seen";

  const TARGET_COUNTRIES = [
    "AL","AD","AT","BY","BE","BA","BG","HR","CY","CZ",
    "DK","EE","FI","FR","DE","GR","HU","IS","IE","IT",
    "XK","LV","LI","LT","LU","MT","MD","MC","ME","NL",
    "MK","NO","PL","PT","RO","SM","RS","SK","SI","ES",
    "SE","CH","UA","GB","VA"
  ];
  
  if (sessionStorage.getItem(STORAGE_KEY)) {
    return;
  }

  // Already seen during this browser session
  if (sessionStorage.getItem(STORAGE_KEY)) {
    return;
  }

  // Don't show on EU store
  if (window.location.hostname.includes("holsteraustralia.eu")) {
    return;
  }

  fetch(
    `https://api.ipinfo.io/lite/me?token=${encodeURIComponent(ACCESS_TOKEN)}`
  )
    .then(function (response) {
      if (!response.ok) {
        throw new Error("IPinfo request failed");
      }
      return response.json();
    })
    .then(function (geo) {
      const countryCode = (geo.country_code || geo.country || "").toUpperCase();
      const countryName = geo.country_name || geo.country || "your country";

      // Australian visitors stay on AU store
      // if (countryCode === "AU") {
      //   return;
      // }

      // Only show for target countries
      if (!TARGET_COUNTRIES.includes(countryCode)) {
        return;
      }

      showPopup(countryCode, countryName);
    })
    .catch(function (error) {
      console.error("Holster EU Popup:", error);
    });

  function countryCodeToFlag(countryCode) {
    return countryCode
      .toUpperCase()
      .split("")
      .map(function (char) {
        return String.fromCodePoint(
          127397 + char.charCodeAt()
        );
      })
      .join("");
  }

  function getStoreName() {
    try {
      const meta = document.querySelector(
        'meta[property="og:site_name"]'
      );

      if (meta && meta.content) {
        return meta.content;
      }

      if (window.Shopify && window.Shopify.shop) {
        return window.Shopify.shop.replace(
          ".myshopify.com",
          ""
        );
      }

      return window.location.hostname
        .replace("www.", "")
        .split(".")[0];
    } catch (e) {
      return "our";
    }
  }

  function showPopup(countryCode, countryName) {
    document.body.style.overflow = "hidden";
    injectStyles();

    const flag = countryCodeToFlag(countryCode);
    const storeName = getStoreName();

    const overlay = document.createElement("div");
    overlay.className = "holster-eu-overlay";

    overlay.innerHTML = `
      <div class="holster-eu-popup">

        <button
          class="holster-eu-close"
          type="button"
          aria-label="Close popup"
        >
          ×
        </button>
        <h2 class="holster-eu-title">
          SHOP CLOSER TO YOU
        </h2>
        <p class="holster-eu-description">
          It looks like you're in
          <strong>${countryName}</strong>.
          <br><br>
          For faster delivery and local pricing,
          you may prefer to visit our European store
        </p>

        <div class="holster-eu-actions">

          <a
            href="https://www.holsteraustralia.eu"
            class="holster-eu-primary"
          >
            Shop European Store
          </a>

          <button
            type="button"
            class="holster-eu-secondary"
          >
            Stay On Australian Store
          </button>

        </div>

      </div>
    `;

    document.body.appendChild(overlay);

    // Close button
    overlay
      .querySelector(".holster-eu-close")
      .addEventListener("click", function () {
        document.body.style.overflow = "";
        overlay.remove();
      });

    // Overlay click
    overlay.addEventListener("click", function (event) {
      if (event.target === overlay) {
        document.body.style.overflow = "";
        overlay.remove();
      }
    });

    // Continue to Australian Store
    overlay
      .querySelector(".holster-eu-secondary")
      .addEventListener("click", function () {

        sessionStorage.setItem(
          STORAGE_KEY,
          "1"
        );
        document.body.style.overflow = "";
        overlay.remove();
      });

    // Shop European Store
    // overlay.querySelector(".holster-eu-primary").addEventListener("click", function () {

    //     sessionStorage.setItem(
    //       STORAGE_KEY,
    //       "1"
    //     );
    //   });
  }

  function injectStyles() {
    if (
      document.getElementById(
        "holster-eu-popup-styles"
      )
    ) {
      return;
    }

    const style = document.createElement("style");

    style.id = "holster-eu-popup-styles";

    style.innerHTML = `
      .holster-eu-overlay{
        position:fixed;
        inset:0;
        background:rgba(0,0,0,.55);
        display:flex;
        align-items:center;
        justify-content:center;
        padding:20px;
        z-index:999999;
      }

      .holster-eu-popup{
        position:relative;
        width:100%;
        max-width:540px;
        background:#ffffff;
        border-radius:12px;
        padding:36px;
        text-align:center;
        font-family:inherit;
        box-sizing:border-box;
      }

      .holster-eu-close{
        position:absolute;
        top:12px;
        right:12px;
        width:36px;
        height:36px;
        border:none;
        background:none;
        cursor:pointer;
        font-size:24px;
        line-height:1;
      }

      .holster-eu-title{
        margin:0 0 16px;
        font-size:20px;
        line-height:1.2;
        font-weight:600;
      }

      .holster-eu-description{
        margin:0 0 28px;
        font-size:16px;
        line-height:1.7;
      }

      .holster-eu-actions{
        display:flex;
        flex-direction:column;
        gap:12px;
      }

      .holster-eu-primary{
        display:block;
        text-decoration:none;
        padding:14px 20px;
        border-radius:6px;
        background:#000;
        color:#fff;
        font-weight:600;
      }

      .holster-eu-primary:hover{
        opacity:.92;
      }

      .holster-eu-secondary{
        cursor:pointer;
        padding:14px 20px;
        border-radius:6px;
        background:#fff;
        color:#000;
        border:1px solid #000;
        font-weight:600;
      }

      @media (max-width:768px){

        .holster-eu-popup{
          padding:24px;
        }

        .holster-eu-title{
          font-size:24px;
        }

        .holster-eu-description{
          font-size:14px;
        }

      }

      .holster-eu-popup .holster-eu-description {
          max-width: 78%;
          margin: 0 auto 30px;
      }

      .holster-eu-popup .holster-eu-primary:hover {
          color:#ffffff;
      }
      @media (max-width: 768px) {
          .holster-eu-popup .holster-eu-description {
              max-width: 100%;
          }
      }
    `;

    document.head.appendChild(style);
  }
})();
